/* eslint-disable no-shadow */
export enum DomainsQueryKeys {
  GetAll = 'domains/getAll',
  GetOneById = 'domains/getById',
  Create = 'domains/create',
  Edit = 'domains/edit',
  Delete = 'domains/delete',
  GetConfig = 'domains/getConfig',
  AttachConfig = 'domains/attachConfig',
  DetachConfig = 'domains/detachConfig',
  UpdateConfig = 'domains/updateConfig',
  Deploy = 'domains/deploy',
  Shutdown = 'domains/shutdown',
  ReloadDeploymentConfig = 'domains/reloadDeploymentConfig',
  Breadcrumb = 'domains/breadcrumb',
  AutocompleteAll = 'domains/autocompleteAll',
  CheckHealth = 'domains/checkHealth',
  MultiConfiguration = 'domains/multiConfiguration',
}

export enum SiteDomainsQueryKeys {
  AutocompleteDomainsBySiteId = 'siteDomains/autocompleteDomains',
  AutocompleteGoogleVerificated = 'domains/autocompleteGoogleVerificated',
  GetAllDomains = 'siteDomains/getAllDomains',
  GetByIdDomains = 'siteDomains/getByIdDomains',
  ChangeMainDomain = 'siteDomains/changeMainDomain',
  DenyAccess = 'siteDomains/denyAccess',
  PurgeCache = 'siteDomains/purgeCache',
}

export enum DomainRegluingsQueryKeys {
  ToggleAutoRegluings = 'domainRegluings/toggleAutoRegluings',
  CreateRegluing = 'domainRegluings/createRegluing',
  GetAllRegluings = 'domainRegluings/getAllRegluings',
  DeleteRegluingById = 'domainRegluings/deleteRegluingById',
}

export enum RobotsQueryKeys {
  GetAllDomains = 'robots/getAllDomain',
  GetById = 'robots/getById',
  Edit = 'robots/edit',
}

export enum SitemapQueryKeys {
  GetAllDomains = 'robots/getAllDomains',
  GetById = 'robots/getById',
  Generate = 'robots/generate',
}

export enum SiteSearchConsoleQueryKeys {
  AddToSite = 'siteSearchConsole/addToSite',
  UnsetFromSite = 'siteSearchConsole/unsetFromSite',
  UpdateInSite = 'siteSearchConsole/updateInSite',
  VerifyGoogleDomain = 'siteSearchConsole/verifyGoogleDomain',
  GetInfo = 'siteSearchConsole/getInfo',
  UpdateRedirectingAutoProcessingSetting = 'siteSearchConsole/updateRedirectingAutoProcessingSetting',
  AddRedirectingTask = 'siteSearchConsole/addRedirectingTask',
}

export enum SearchConsoleSitemapDomainsQueryKeys {
  GetAll = 'searchConsoleSitemapDomains/getAll',
  GetById = 'searchConsoleSitemapDomains/getById',
  Submit = 'searchConsoleSitemapDomains/submit',
}

export enum SearchConsoleAnalyticsDomainsQueryKeys {
  GetAll = 'searchConsoleAnalyticsDomains/getAll',
  GetById = 'searchConsoleAnalyticsDomains/getById',
  Submit = 'searchConsoleAnalyticsDomains/submit',
}

export enum SearchConsoleUrlInspectionDomainsQueryKeys {
  GetAll = 'searchConsoleUrlInspectionDomains/getAll',
  GetById = 'searchConsoleUrlInspectionDomains/getById',
  Inspect = 'searchConsoleUrlInspectionDomains/inspect',
}

export enum SearchConsoleIndexingQueryKeys {
  PushIndexing = 'siteSearchConsoleIndexing/pushIndexing',
}
